import { BoostOffersResponse } from '@woolworthsnz/trader-api';

export const boostOffersResponseMock: BoostOffersResponse = {
	offers: [
		{
			id: '2926200304',
			campaignId: '1446542',
			heading: 'Collect 150 points',
			description: {
				listShort: 'on Ziploc Snack 60 pack',
				detailed: 'on Ziploc Snack 60 pack in-store or online at Countdown until Saturday, 30 Sep.* ',
				list: 'on Ziploc Snack 60 pack',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 (local time) 12/02/2024 until 23:59 (local time) 18/02/2024 at Countdown Supermarkets, Countdown Metro and Countdown Online. Offer period is based on the local time of the store you shop at in-store or that fulfils your Woolworths Online order. This offer is personal to you, and will only be available on your Everyday Rewards Card. Registered Everyday Rewards members must boost this offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, boost your offer before shopping in-store or online. ^Points offer is only valid for each listed product in the size and variant described in this email. Pricing and stock availability may vary by store. To enjoy your offer in-store, you must boost this offer and scan your Everyday Rewards Card before completing your transaction; to enjoy your offer online, ensure your Everyday Rewards Card number is linked to your online account at checkout. For all Countdown Online transactions, orders need to be placed by 23:59 (local time) on 29/11/22 to collect 200 points. Offer can be enjoyed multiple times during the promotional period. If you are eligible for multiple points offers on the same product, 1 standard point will be collected once only for all such offers, plus the applicable number of additional points. See [www.Countdown.co.nz](https://www.Countdown.co.nz) for full Terms and Conditions applicable to shopping at Countdown Online. Your Everyday Rewards points will be loaded onto your Everyday Rewards Card within 5 days  after your qualifying shop. You will not collect any points on any qualifying shop in the promotional period before boosting your offer. In addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards T&Cs at [www.everydayrewards.co.nz/terms](https://www.everydayrewards.co.nz/terms)\n\nCampaign code: ITM-0002',
			offerStatus: 'Activated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 150.0,
				value: 150.0,
				type: 'points_fixed',
				display: '150',
			},
			backgroundImage: {
				desktop: 'https://assets.woolworths.com.au/images/2010/71358.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				mobile: 'https://assets.woolworths.com.au/images/2010/71358.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				altText: 'Ziploc Snack 60 pack',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 1,
				remaining: 1,
				eligibleSalesChannels: ['ONLINE_WEB', 'ONLINE_APP', 'INSTORE', 'INSTORE_SELF_CHECKOUT', 'SCAN_AND_GO'],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 5,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Shop',
			},
			offerType: 'OTHER',
			minimumSpend: 1015,
			displayLocation: 'PRODUCT_OFFERS',
		},
		{
			id: '2926200305',
			campaignId: '1486177',
			heading: 'Heading for welcome offers',
			description: {
				listShort: 'Short description for welcome offers',
				detailed: 'Detailed description for welcome offers',
				list: 'List description for welcome offers',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 (local time) 12/02/2024 until 23:59 (local time) 18/02/2024 at Countdown Supermarkets, Countdown Metro and Countdown Online. Offer period is based on the local time of the store you shop at in-store or that fulfils your Countdown Online order. This offer is personal to you, and will only be available on your Everyday Rewards Card. Registered Everyday Rewards members must boost this offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, boost your offer before shopping in-store or online. ^Points offer is only valid for each listed product in the size and variant described in this email. Pricing and stock availability may vary by store. To enjoy your offer in-store, you must boost this offer and scan your Everyday Rewards Card before completing your transaction; to enjoy your offer online, ensure your Everyday Rewards Card number is linked to your online account at checkout. For all Countdown Online transactions, orders need to be placed by 23:59 (local time) on 18/02/2024 to collect 200 points. Offer can be enjoyed multiple times during the promotional period. If you are eligible for multiple points offers on the same product, 1 standard point will be collected once only for all such offers, plus the applicable number of additional points. See www.Countdown.co.nz for full Terms and Conditions applicable to shopping at Countdown Online. Your Everyday Rewards points will be loaded onto your Everyday Rewards Card within 5 days  after your qualifying shop. You will not collect any points on any qualifying shop in the promotional period before boosting your offer. In addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards T&Cs at www.everydayrewards.co.nz/terms\n\nCampaign code: ITM-0001',
			offerStatus: 'NotActivated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 200.0,
				value: 200.0,
				type: 'discount_products_dollars_off',
				display: '$2.00',
			},
			backgroundImage: {
				desktop:
					'https://www.countdown.co.nz/images/global-nav/christmaswapple/countdown-desktop-logo-xmas.svg',
				mobile: 'https://www.countdown.co.nz/images/global-nav/christmaswapple/countdown-desktop-logo-xmas.svg',
				altText: 'Image alt test for welcome offers',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 2,
				remaining: 2,
				eligibleSalesChannels: ['ONLINE_WEB', 'ONLINE_APP', 'INSTORE', 'INSTORE_SELF_CHECKOUT', 'SCAN_AND_GO'],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 2,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Boost',
			},
			offerType: 'OTHER',
			minimumSpend: 1,
			displayLocation: 'PRODUCT_OFFERS',
		},
		{
			id: '2926200306',
			campaignId: '1507778',
			heading: 'Spend $50 on basket sale and  collect 3x points -H',
			description: {
				listShort: 'Spend $50 on basket sale and  collect 3x points  -SD*',
				detailed:
					'On every shop in-store or online at Woolworths from Monday, 12 February to Sunday, 18 February.*',
				list: 'Spend $50 on basket sale and  collect 3x points  Monday, 12 February.* -LD',
			},
			termsAndConditions:
				"*Offer runs from 00:01 12/02/2024 on 12/02/2024 to 23:59 18/02/2024. Offer is available at Woolworths supermarkets, Woolworths Metro and Woolworths Online. Offer is not available on items purchased from Everyday Market from Woolworths or at any Ampol Woolworths Metro. This offer is personal to you and will be available only on your Everyday Rewards Card. Registered Everyday Rewards members must boost their offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, you must boost your offer at least 2 hours before shopping. Boosting closes 23:59 {{activation_end}} Sunday {{activation_end|DD/MM/YYYY}}. Any transactions you have made at Woolworths during the offer period before boosting your offer will not qualify for 3x points. 3x points equals 1 (one) standard Everyday Rewards point and 1 (one) additional Everyday Rewards points. Offer can be enjoyed multiple times. If eligible for multiple points boosters, only 1 (one) standard Everyday Rewards point can be collected once for all eligible offers, plus the applicable number of additional points. To enjoy your offer in-store, you must scan your Everyday Rewards Card before completing the transaction at the checkout. To enjoy your offer online at https://www.woolworths.com.au/ you will need to ensure your registered Everyday Rewards Card number is linked to your Woolworths Online account prior to completing your order. For all Woolworths Online transactions, orders need to be delivered or picked up by 23:59 18/02/2024 Sunday 18/02/2024 to qualify for 3x points. See https://www.woolworths.com.au/ for full terms and conditions and delivery areas. Your points will be loaded instantly to your Everyday Rewards Card after each qualifying shop. There are a small number of purchases on which you won't collect points. For details, see this https://www.woolworthsrewards.com.au/support.html?id=231.\n\nIn addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the https://www.woolworthsrewards.com.au/terms.html.\n\nCampaign Code: BAS-0004",
			offerStatus: 'Activated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 3.0,
				value: 3.0,
				type: 'points_multiplier',
				display: '3x',
			},
			backgroundImage: {
				desktop: 'https://my.woolworthsrewards.com.au/sf/CVM-3509/CVM3509_MMM_SPRING_2021_1600x800.png',
				mobile: 'https://my.woolworthsrewards.com.au/sf/CVM-3509/CVM3509_MMM_SPRING_2021_1600x800.png',
				altText: 'Testing -3-Multiplier',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 0,
				remaining: 0,
				eligibleSalesChannels: [
					'ONLINE_WEB',
					'ONLINE_APP',
					'INSTORE',
					'INSTORE_SELF_CHECKOUT',
					'SCAN_AND_GO',
					'LAYBY',
					'WPAY',
				],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 0,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Shop',
			},
			offerType: 'OTHER',
			minimumSpend: 5000,
			displayLocation: 'OTHER_OFFERS',
		},
		{
			id: '2926200307',
			campaignId: '1507894',
			heading: 'Collect 3000/2000/1000 for spend $200/100/1 Respectively ',
			description: {
				listShort: '*',
				detailed:
					'Collect 3000/2000/1000 for total basket spend  $200/100/1 Respectively ^ at Countdown until Sunday 18/February*',
				list: 'on basket spend Collect 3000/2000/1000 for spend $200/100/1 Respectively at Countdown*',
			},
			termsAndConditions:
				'*Promotion runs from 00:01  12/02/2024 until 23:59 18/02/2024. Offer available at  at Countdown . This offer is personal to you and will be available only on your Everyday Rewards Card. Registered Everyday Rewards members must boost their offer to participate in the promotion. You can boost your offer anytime from receiving this email until the end of the promotional period. To ensure your offer has been added to your Everyday Rewards Card, you must boost your offer at least 2 hours before shopping in-store or online. Any qualifying transactions you have made at Countdown in the promotional period before boosting your offer will not qualify for 1000/2000/3000 points. Spend at least $1/100/200(the qualifying amount) in one transaction on Fuel in-store during the promotional period to collect 1000/2000/3000 points. Offer can be enjoyed multiple times. If eligible for multiple points boosters, only 1 (one) standard Everyday Rewards point can be collected once for all eligible offers, plus the applicable number of bonus points. To enjoy your offer in-store, you must scan your Everyday Rewards Card before completing the transaction at the checkout.  This promotion is valid on fuel. This promotion excludes Tobaco purchase.\n\nIn addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards Terms and Conditions at https://www.countdown.co.nz/info/terms-and-conditions',
			offerStatus: 'NotActivated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 3000.0,
				value: 3000.0,
				type: 'points_fixed',
				display: '3000',
			},
			backgroundImage: {
				desktop: 'https://my.woolworthsrewards.com.au/sf/CVM-3525/CVM3525_MMM_SPRING_2021_1600x800.png',
				mobile: 'https://my.woolworthsrewards.com.au/sf/CVM-3525/CVM3525_MMM_SPRING_2021_1600x800.png',
				altText: '',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 0,
				remaining: 0,
				eligibleSalesChannels: [
					'ONLINE_WEB',
					'ONLINE_APP',
					'INSTORE',
					'INSTORE_SELF_CHECKOUT',
					'SCAN_AND_GO',
					'LAYBY',
					'WPAY',
				],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 0,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Boost',
			},
			offerType: 'OTHER',
			minimumSpend: 100,
			displayLocation: 'OTHER_OFFERS',
		},
		{
			id: '2926200308',
			campaignId: '1511938',
			heading: 'countdown basket discount 5% spend 100$ -H',
			description: {
				listShort: 'countdown basket discount 5% spend 100$ -SD',
				detailed:
					'countdown basket discount 5% spend 100$^ when you shop and scan your Everyday Rewards Card in-store at countdown until Sunday, 18 February.* -DD',
				list: 'countdown basket discount 5% spend 100$ -LD',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 12/02/2024 until 23:59 18/02/2024. Offer available at  at Countdown . This offer is personal to you and will be available only on your Everyday Rewards Card. Registered Everyday Rewards members must boost their offer to participate in the promotion. You can boost your offer anytime from receiving this email until the end of the promotional period. To ensure your offer has been added to your Everyday Rewards Card, you must boost your offer at least 2 hours before shopping in-store or online. Any qualifying transactions you have made at Countdown in the promotional period before boosting your offer will not qualify for 5% discount. Spend at least $150(the qualifying amount) in one transaction on Fuel in-store during the promotional period to get 5% discount. Offer can be enjoyed multiple times. If eligible for multiple points boosters, only 1 (one) standard Everyday Rewards point can be collected once for all eligible offers, plus the applicable number of bonus points. To enjoy your offer in-store, you must scan your Everyday Rewards Card before completing the transaction at the checkout.  This promotion is valid on fuel. This promotion excludes Tobaco purchase.\n\nIn addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards Terms and Conditions at https://www.countdown.co.nz/info/terms-and-conditions',
			offerStatus: 'NotActivated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 5.0,
				value: 5.0,
				type: 'discount_basket_percentage_off',
				display: '5%',
			},
			backgroundImage: {
				desktop: 'https://my.woolworthsrewards.com.au/sf/CVM-3525/CVM3525_MMM_SPRING_2021_1600x800.png',
				mobile: 'https://my.woolworthsrewards.com.au/sf/CVM-3525/CVM3525_MMM_SPRING_2021_1600x800.png',
				altText: 'Test',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 0,
				remaining: 0,
				eligibleSalesChannels: ['INSTORE', 'INSTORE_SELF_CHECKOUT', 'SCAN_AND_GO'],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 0,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Boost',
			},
			offerType: 'OTHER',
			minimumSpend: 10000,
			displayLocation: 'OTHER_OFFERS',
		},
		{
			id: '2926200309',
			campaignId: '1511941',
			heading: 'Shop to collect 1000 points',
			description: {
				listShort: 'Shop to collect 1000  points*',
				detailed:
					'Spend $50 in one shop, in-store or online at Woolworths to collect 1000 points. Starts Monday, 12 February ends Sunday, 18 February.* This is countdown specific offer',
				list: 'Spend $50 in one shop. Starts Mon 12 Feb.*',
			},
			termsAndConditions:
				"*Offer runs from 00:01 12/02/2024 on 12/02/2024 to 23:59  18/02/2024. Offer is available at Woolworths supermarkets, Woolworths Metro and Woolworths Online. Offer is not available on items purchased from Everyday Market from Woolworths or at any Ampol Woolworths Metro. This offer is personal to you and will be available only on your Everyday Rewards Card. Registered Everyday Rewards members must boost their offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, you must boost your offer at least 2 hours before shopping. Boosting closes 23:59 {{activation_end}} Sunday {{activation_end|DD/MM/YYYY}}. Any transactions you have made at Woolworths in the offer period before boosting your offer will not be counted towards the qualifying amount. Spend at least $50 in a single transaction for 1000 points. This offer can only be enjoyed once during the promotional period. To enjoy your offer in-store, you must scan your Everyday Rewards Card before completing the transaction at the checkout. To enjoy your offer online at https://www.woolworths.com.au/, you will need to ensure your registered Everyday Rewards Card number is linked to your Woolworths Online account prior to completing your order. For all Woolworths Online transactions, orders need to be delivered or picked up by 23:59 18/02/2024 Sunday 18/02/2024 to qualify for your points offer. See https://www.woolworths.com.au/ for full terms and conditions and delivery areas. Your points will be loaded to your Everyday Rewards Card within 3 business days after your qualifying shop. There are a small number of purchases on which you won't collect points. For details, see this https://www.woolworthsrewards.com.au/support.html?id=231.\n\nIn addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the https://www.woolworthsrewards.com.au/terms.html.\n\nCampaign Code: FPB-0001",
			offerStatus: 'NotActivated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 1000.0,
				value: 1000.0,
				type: 'points_fixed',
				display: '1000',
			},
			backgroundImage: {
				desktop: 'https://my.woolworthsrewards.com.au/sf/CVM-3525/CVM3525_MMM_SPRING_2021_1600x800.png',
				mobile: 'https://my.woolworthsrewards.com.au/sf/CVM-3525/CVM3525_MMM_SPRING_2021_1600x800.png',
				altText: 'Testing',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 0,
				remaining: 0,
				eligibleSalesChannels: [
					'ONLINE_WEB',
					'ONLINE_APP',
					'INSTORE',
					'INSTORE_SELF_CHECKOUT',
					'SCAN_AND_GO',
					'LAYBY',
					'WPAY',
				],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 0,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Boost',
			},
			offerType: 'OTHER',
			minimumSpend: 5000,
			displayLocation: 'OTHER_OFFERS',
		},
		{
			id: '2926200310',
			campaignId: '1512765',
			heading: 'countdown basket discount 25$ spend 150$',
			description: {
				listShort: 'countdown basket discount 25$ spend 150$',
				detailed:
					'countdown basket discount 25$ spend 150$^ when you shop and scan your Everyday Rewards Card in-store at countdown until Sunday, 18 February.*',
				list: 'countdown basket discount 25$ spend 150$',
			},
			termsAndConditions:
				'*Promotion runs from 00:01  12/02/2024 until 23:59 18/02/2024. Offer available at  at Countdown . This offer is personal to you and will be available only on your Everyday Rewards Card. Registered Everyday Rewards members must boost their offer to participate in the promotion. You can boost your offer anytime from receiving this email until the end of the promotional period. To ensure your offer has been added to your Everyday Rewards Card, you must boost your offer at least 2 hours before shopping in-store or online. Any qualifying transactions you have made at Countdown in the promotional period before boosting your offer will not qualify for $25 discount. Spend at least $150(the qualifying amount) in one transaction on Fuel in-store during the promotional period to get $25 discount. Offer can be enjoyed multiple times. If eligible for multiple points boosters, only 1 (one) standard Everyday Rewards point can be collected once for all eligible offers, plus the applicable number of bonus points. To enjoy your offer in-store, you must scan your Everyday Rewards Card before completing the transaction at the checkout.  This promotion is valid on fuel. This promotion excludes Tobaco purchase.\n\nIn addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards Terms and Conditions at https://www.countdown.co.nz/info/terms-and-conditions',
			offerStatus: 'NotActivated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 2500.0,
				value: 2500.0,
				type: 'discount_basket_dollars_off',
				display: '$25.00',
			},
			backgroundImage: {
				desktop: 'https://my.woolworthsrewards.com.au/sf/CVM-3525/CVM3525_MMM_SPRING_2021_1600x800.png',
				mobile: 'https://my.woolworthsrewards.com.au/sf/CVM-3525/CVM3525_MMM_SPRING_2021_1600x800.png',
				altText: 'Test',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 0,
				remaining: 0,
				eligibleSalesChannels: [
					'ONLINE_WEB',
					'ONLINE_APP',
					'INSTORE',
					'INSTORE_SELF_CHECKOUT',
					'SCAN_AND_GO',
					'LAYBY',
					'WPAY',
				],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 0,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Boost',
			},
			offerType: 'OTHER',
			minimumSpend: 15000,
			displayLocation: 'OTHER_OFFERS',
		},
		{
			id: '2926200311',
			campaignId: '1520879',
			heading: 'Free Coke Zero Sugar',
			description: {
				listShort: 'Free Coke Zero Sugar1.5l in-store at Countdown*',
				detailed: 'Get your free Coke Zero Sugar  Free 1.5l^ in-store at Countdown until Tue, 28 Feb.*',
				list: 'Free Coke Zero Sugar1.5l in-store at Countdown*',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 (local time) 12/02/2024 until 23:59 (local time) 18/02/2024 at Countdown Supermarkets, Countdown Metro and Countdown Online. Offer period is based on the local time of the store you shop at in-store or that fulfils your Countdown Online order. This offer is personal to you, and will only be available on your Everyday Rewards Card. Registered Everyday Rewards members must boost this offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, boost your offer before shopping in-store or online. ^Points offer is only valid for each listed product in the size and variant described in this email. Pricing and stock availability may vary by store. To enjoy your offer in-store, you must boost this offer and scan your Everyday Rewards Card before completing your transaction; to enjoy your offer online, ensure your Everyday Rewards Card number is linked to your online account at checkout. For all Countdown Online transactions, orders need to be placed by 23:59 (local time) on 18/02/2024 to collect 100 points. Offer can be enjoyed multiple times during the promotional period. If you are eligible for multiple points offers on the same product, 1 standard point will be collected once only for all such offers, plus the applicable number of additional points. See [www.Countdown.co.nz](https://www.Countdown.co.nz) for full Terms and Conditions applicable to shopping at Countdown Online. Your Everyday Rewards points will be loaded onto your Everyday Rewards Card within 5 days  after your qualifying shop. You will not collect any points on any qualifying shop in the promotional period before boosting your offer. In addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards T&Cs at [www.everydayrewards.co.nz/terms](https://www.everydayrewards.co.nz/terms)\n\nCampaign code: CAR-0001\n',
			offerStatus: 'Activated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 100.0,
				value: 100.0,
				type: 'discount_products_percentage_off',
				display: '100%',
			},
			backgroundImage: {
				desktop: 'https://assets.woolworths.com.au/images/2010/227760.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				mobile: 'https://assets.woolworths.com.au/images/2010/227760.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				altText: 'Coke Zero Sugar  Free 1.5l',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 0,
				remaining: 0,
				eligibleSalesChannels: ['ONLINE_WEB', 'ONLINE_APP', 'INSTORE', 'INSTORE_SELF_CHECKOUT', 'SCAN_AND_GO'],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 1,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Shop',
			},
			offerType: 'OTHER',
			minimumSpend: 1,
			displayLocation: 'PRODUCT_OFFERS',
		},
		{
			id: '2926200312',
			campaignId: '1560528',
			heading: 'Collect 700 points',
			description: {
				listShort: 'on Pet Culture products at Countdown. Offer ends Sunday, 18 February.*',
				detailed: 'When you shop Pet products, in-store or online at Countdown until Sunday, 18 February.*',
				list: 'on Pet Culture products at Countdown. Offer ends Sunday, 18 February.*',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 (local time) 12/02/2024 until 23:59 (local time) 18/02/2024 at Countdown Supermarkets, Countdown Metro and Countdown Online. Offer period is based on the local time of the store you shop at in-store or that fulfils your Countdown Online order. This offer is personal to you, and will only be available on your Everyday Rewards Card. Registered Everyday Rewards members must boost this offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, boost your offer before shopping in-store or online. ^Points offer is only valid for each listed product in the size and variant described in this email. Pricing and stock availability may vary by store. To enjoy your offer in-store, you must boost this offer and scan your Everyday Rewards Card before completing your transaction; to enjoy your offer online, ensure your Everyday Rewards Card number is linked to your online account at checkout. For all Countdown Online transactions, orders need to be placed by 23:59 (local time) on 18/02/2024 to collect 700 points. Offer can be enjoyed multiple times during the promotional period. If you are eligible for multiple points offers on the same product, 1 standard point will be collected once only for all such offers, plus the applicable number of additional points. See [www.Countdown.co.nz](https://www.Countdown.co.nz) for full Terms and Conditions applicable to shopping at Countdown Online. Your Everyday Rewards points will be loaded onto your Everyday Rewards Card within 5 days  after your qualifying shop. You will not collect any points on any qualifying shop in the promotional period before boosting your offer. In addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards T&Cs at [www.everydayrewards.co.nz/terms](https://www.everydayrewards.co.nz/terms)\n\nCampaign code: CTG-0001\n',
			offerStatus: 'NotActivated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 700.0,
				value: 700.0,
				type: 'points_fixed',
				display: '700',
			},
			backgroundImage: {
				desktop: 'https://assets.woolworths.com.au/images/2010/57005.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				mobile: 'https://assets.woolworths.com.au/images/2010/57005.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				altText: 'Pet Detective category offer',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 0,
				remaining: 0,
				eligibleSalesChannels: ['ONLINE_WEB', 'ONLINE_APP', 'INSTORE', 'INSTORE_SELF_CHECKOUT'],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 0,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Boost',
			},
			offerType: 'OTHER',
			minimumSpend: 1500,
			displayLocation: 'OTHER_OFFERS',
		},
		{
			id: '2323213123',
			campaignId: '1614281',
			heading: 'REDEEEEMED Other',
			description: {
				listShort: 'Wow Pizza Base Kits 10x260g and coco*',
				detailed:
					'Wow Pizza Base Kits 10x260g and coco* in-store or online at Countdown until Saturday, 30 Sep.* ',
				list: 'Wow Pizza Base Kits 10x260g and coco*',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 (local time) 22/07/2024 until 23:59 (local time) 28/07/2024 at Countdown Supermarkets, Countdown Metro and Countdown Online. Offer period is based on the local time of the store you shop at in-store or that fulfils your Woolworths Online order. This offer is personal to you, and will only be available on your Everyday Rewards Card. Registered Everyday Rewards members must boost this offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, boost your offer before shopping in-store or online. ^Points offer is only valid for each listed product in the size and variant described in this email. Pricing and stock availability may vary by store. To enjoy your offer in-store, you must boost this offer and scan your Everyday Rewards Card before completing your transaction; to enjoy your offer online, ensure your Everyday Rewards Card number is linked to your online account at checkout. For all Countdown Online transactions, orders need to be placed by 23:59 (local time) on 29/11/22 to collect 200 points. Offer can be enjoyed multiple times during the promotional period. If you are eligible for multiple points offers on the same product, 1 standard point will be collected once only for all such offers, plus the applicable number of additional points. See [www.Countdown.co.nz](https://www.Countdown.co.nz) for full Terms and Conditions applicable to shopping at Countdown Online. Your Everyday Rewards points will be loaded onto your Everyday Rewards Card within 5 days  after your qualifying shop. You will not collect any points on any qualifying shop in the promotional period before boosting your offer. In addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards T&Cs at [www.everydayrewards.co.nz/terms](https://www.everydayrewards.co.nz/terms)\n\nCampaign code: ITM-0002',
			offerStatus: 'Redeemed',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 150.0,
				value: 150.0,
				type: 'points_fixed',
				display: '150',
			},
			backgroundImage: {
				desktop: 'https://assets.woolworths.com.au/images/2010/260697.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				mobile: 'https://assets.woolworths.com.au/images/2010/260697.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				altText: 'Wow Pizza Base Kits 10x260g and coco',
			},
			redemption: {
				startDate: '2024-07-22T00:01:06+12:00',
				endDate: '2024-07-28T23:59:06+12:00',
				total: 1,
				remaining: 1,
				eligibleSalesChannels: ['ONLINE_WEB', 'ONLINE_APP', 'INSTORE', 'INSTORE_SELF_CHECKOUT', 'SCAN_AND_GO'],
			},
			activation: {
				startDate: '2024-07-22T00:01:06+12:00',
				endDate: '2024-07-28T23:59:06+12:00',
			},
			products: [],
			productCount: 10,
			cta: {
				destinationUrl: 'https://wwwuat.woolworths.co.nz/shop/everyday-rewards-boosts/1614281',
				dateMessage: 'Ends 28 Jul',
				label: 'Shop',
			},
			offerType: 'OTHER',
			minimumSpend: 0,
			displayLocation: 'OTHER_OFFERS',
		},
		{
			id: '2926200313',
			campaignId: '1582614',
			heading: 'Essano Body Lotion Van & Chia Seed400ml',
			description: {
				listShort: 'Essano Body Lotion Van & Chia Seed400ml^ in-store at Countdown**',
				detailed: 'Essano Body Lotion Van & Chia Seed400ml^ in-store at Countdown until Tue, 28 Feb.*',
				list: 'Essano Body Lotion Van & Chia Seed400ml^ in-store at Countdown**',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 (local time) 12/02/2024 until 23:59 (local time) 18/02/2024 at Countdown Supermarkets, Countdown Metro and Countdown Online. Offer period is based on the local time of the store you shop at in-store or that fulfils your Countdown Online order. This offer is personal to you, and will only be available on your Everyday Rewards Card. Registered Everyday Rewards members must boost this offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, boost your offer before shopping in-store or online. ^Points offer is only valid for each listed product in the size and variant described in this email. Pricing and stock availability may vary by store. To enjoy your offer in-store, you must boost this offer and scan your Everyday Rewards Card before completing your transaction; to enjoy your offer online, ensure your Everyday Rewards Card number is linked to your online account at checkout. For all Countdown Online transactions, orders need to be placed by 23:59 (local time) on 18/02/2024 to collect 500 points. Offer can be enjoyed multiple times during the promotional period. If you are eligible for multiple points offers on the same product, 1 standard point will be collected once only for all such offers, plus the applicable number of additional points. See [www.Countdown.co.nz](https://www.Countdown.co.nz) for full Terms and Conditions applicable to shopping at Countdown Online. Your Everyday Rewards points will be loaded onto your Everyday Rewards Card within 5 days  after your qualifying shop. You will not collect any points on any qualifying shop in the promotional period before boosting your offer. In addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards T&Cs at [www.everydayrewards.co.nz/terms](https://www.everydayrewards.co.nz/terms)\n\nCampaign code: CAR-0001\n',
			offerStatus: 'Activated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 500.0,
				value: 500.0,
				type: 'discount_products_dollars_off',
				display: '$5.00',
			},
			backgroundImage: {
				desktop: 'https://assets.woolworths.com.au/images/2010/227760.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				mobile: 'https://assets.woolworths.com.au/images/2010/227760.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				altText: 'Essano Body Lotion Van & Chia Seed400ml',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 0,
				remaining: 0,
				eligibleSalesChannels: ['INSTORE', 'INSTORE_SELF_CHECKOUT', 'SCAN_AND_GO'],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 3,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Shop',
			},
			offerType: 'OTHER',
			minimumSpend: 1,
			displayLocation: 'PRODUCT_OFFERS',
		},
		{
			id: '2926200314',
			campaignId: '1582698',
			heading: 'Eveready Brilliant Beam 2aa Torch',
			description: {
				listShort: 'Eveready Brilliant Beam 2aa Torch in-store at Countdown*',
				detailed: 'Eveready Brilliant Beam 2aa Torch^ in-store at Countdown until Tue, 28 Feb.*',
				list: 'Eveready Brilliant Beam 2aa Torch in-store at Countdown*',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 (local time) 12/02/2024 until 23:59 (local time) 18/02/2024 at Countdown Supermarkets, Countdown Metro and Countdown Online. Offer period is based on the local time of the store you shop at in-store or that fulfils your Countdown Online order. This offer is personal to you, and will only be available on your Everyday Rewards Card. Registered Everyday Rewards members must boost this offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, boost your offer before shopping in-store or online. ^Points offer is only valid for each listed product in the size and variant described in this email. Pricing and stock availability may vary by store. To enjoy your offer in-store, you must boost this offer and scan your Everyday Rewards Card before completing your transaction; to enjoy your offer online, ensure your Everyday Rewards Card number is linked to your online account at checkout. For all Countdown Online transactions, orders need to be placed by 23:59 (local time) on 18/02/2024 to collect 500 points. Offer can be enjoyed multiple times during the promotional period. If you are eligible for multiple points offers on the same product, 1 standard point will be collected once only for all such offers, plus the applicable number of additional points. See [www.Countdown.co.nz](https://www.Countdown.co.nz) for full Terms and Conditions applicable to shopping at Countdown Online. Your Everyday Rewards points will be loaded onto your Everyday Rewards Card within 5 days  after your qualifying shop. You will not collect any points on any qualifying shop in the promotional period before boosting your offer. In addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards T&Cs at [www.everydayrewards.co.nz/terms](https://www.everydayrewards.co.nz/terms)\n\nCampaign code: CAR-0001\n',
			offerStatus: 'NotActivated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 500.0,
				value: 500.0,
				type: 'discount_products_fixed_price',
				display: '$5.00',
			},
			backgroundImage: {
				desktop: 'https://assets.woolworths.com.au/images/2010/227760.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				mobile: 'https://assets.woolworths.com.au/images/2010/227760.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				altText: 'Eveready Brilliant Beam 2aa Torch',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 0,
				remaining: 0,
				eligibleSalesChannels: ['INSTORE', 'INSTORE_SELF_CHECKOUT', 'SCAN_AND_GO'],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 1,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Boost',
			},
			offerType: 'OTHER',
			minimumSpend: 1,
			displayLocation: 'PRODUCT_OFFERS',
		},
		{
			id: '2926200315',
			campaignId: '1582767',
			heading: 'Pavillion Beef&GravyPies 360g',
			description: {
				listShort: 'Pavillion Beef&GravyPies 360g in-store at Countdown**',
				detailed: 'Pavillion Beef&GravyPies 360g^ in-store at Countdown until Tue, 28 Feb.*',
				list: 'Pavillion Beef&GravyPies 360g in-store at Countdown**',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 (local time) 12/02/2024 until 23:59 (local time) 18/02/2024 at Countdown Supermarkets, Countdown Metro and Countdown Online. Offer period is based on the local time of the store you shop at in-store or that fulfils your Countdown Online order. This offer is personal to you, and will only be available on your Everyday Rewards Card. Registered Everyday Rewards members must boost this offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, boost your offer before shopping in-store or online. ^Points offer is only valid for each listed product in the size and variant described in this email. Pricing and stock availability may vary by store. To enjoy your offer in-store, you must boost this offer and scan your Everyday Rewards Card before completing your transaction; to enjoy your offer online, ensure your Everyday Rewards Card number is linked to your online account at checkout. For all Countdown Online transactions, orders need to be placed by 23:59 (local time) on 18/02/2024 to collect 20 points. Offer can be enjoyed multiple times during the promotional period. If you are eligible for multiple points offers on the same product, 1 standard point will be collected once only for all such offers, plus the applicable number of additional points. See [www.Countdown.co.nz](https://www.Countdown.co.nz) for full Terms and Conditions applicable to shopping at Countdown Online. Your Everyday Rewards points will be loaded onto your Everyday Rewards Card within 5 days  after your qualifying shop. You will not collect any points on any qualifying shop in the promotional period before boosting your offer. In addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards T&Cs at [www.everydayrewards.co.nz/terms](https://www.everydayrewards.co.nz/terms)\n\nCampaign code: CAR-0001\n',
			offerStatus: 'NotActivated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 20.0,
				value: 20.0,
				type: 'discount_products_percentage_off',
				display: '20%',
			},
			backgroundImage: {
				desktop: 'https://assets.woolworths.com.au/images/2010/227760.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				mobile: 'https://assets.woolworths.com.au/images/2010/227760.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				altText: 'Pavillion Beef&GravyPies 360g',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 0,
				remaining: 0,
				eligibleSalesChannels: ['INSTORE', 'INSTORE_SELF_CHECKOUT', 'SCAN_AND_GO'],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 4,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Boost',
			},
			offerType: 'OTHER',
			minimumSpend: 1,
			displayLocation: 'PRODUCT_OFFERS',
		},
		{
			id: '3559304600',
			campaignId: '1614281',
			heading: 'REDEEEEMED',
			description: {
				listShort: 'Wow Pizza Base Kits 10x260g and coco*',
				detailed:
					'Wow Pizza Base Kits 10x260g and coco* in-store or online at Countdown until Saturday, 30 Sep.* ',
				list: 'Wow Pizza Base Kits 10x260g and coco*',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 (local time) 22/07/2024 until 23:59 (local time) 28/07/2024 at Countdown Supermarkets, Countdown Metro and Countdown Online. Offer period is based on the local time of the store you shop at in-store or that fulfils your Woolworths Online order. This offer is personal to you, and will only be available on your Everyday Rewards Card. Registered Everyday Rewards members must boost this offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, boost your offer before shopping in-store or online. ^Points offer is only valid for each listed product in the size and variant described in this email. Pricing and stock availability may vary by store. To enjoy your offer in-store, you must boost this offer and scan your Everyday Rewards Card before completing your transaction; to enjoy your offer online, ensure your Everyday Rewards Card number is linked to your online account at checkout. For all Countdown Online transactions, orders need to be placed by 23:59 (local time) on 29/11/22 to collect 200 points. Offer can be enjoyed multiple times during the promotional period. If you are eligible for multiple points offers on the same product, 1 standard point will be collected once only for all such offers, plus the applicable number of additional points. See [www.Countdown.co.nz](https://www.Countdown.co.nz) for full Terms and Conditions applicable to shopping at Countdown Online. Your Everyday Rewards points will be loaded onto your Everyday Rewards Card within 5 days  after your qualifying shop. You will not collect any points on any qualifying shop in the promotional period before boosting your offer. In addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards T&Cs at [www.everydayrewards.co.nz/terms](https://www.everydayrewards.co.nz/terms)\n\nCampaign code: ITM-0002',
			offerStatus: 'Redeemed',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 150.0,
				value: 150.0,
				type: 'points_fixed',
				display: '150',
			},
			backgroundImage: {
				desktop: 'https://assets.woolworths.com.au/images/2010/260697.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				mobile: 'https://assets.woolworths.com.au/images/2010/260697.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				altText: 'Wow Pizza Base Kits 10x260g and coco',
			},
			redemption: {
				startDate: '2024-07-22T00:01:06+12:00',
				endDate: '2024-07-28T23:59:06+12:00',
				total: 1,
				remaining: 1,
				eligibleSalesChannels: ['ONLINE_WEB', 'ONLINE_APP', 'INSTORE', 'INSTORE_SELF_CHECKOUT', 'SCAN_AND_GO'],
			},
			activation: {
				startDate: '2024-07-22T00:01:06+12:00',
				endDate: '2024-07-28T23:59:06+12:00',
			},
			products: [],
			productCount: 10,
			cta: {
				destinationUrl: 'https://wwwuat.woolworths.co.nz/shop/everyday-rewards-boosts/1614281',
				dateMessage: 'Ends 28 Jul',
				label: 'Shop',
			},
			offerType: 'OTHER',
			minimumSpend: 0,
			displayLocation: 'PRODUCT_OFFERS',
		},
		{
			id: '2926200316',
			campaignId: '1582850',
			heading: 'Collect 150 points',
			description: {
				listShort: 'on Ziploc Snack 60 pack',
				detailed: 'on Ziploc Snack 60 pack in-store or online at Countdown until Saturday, 30 Sep.* ',
				list: 'on Ziploc Snack 60 pack',
			},
			termsAndConditions:
				'*Promotion runs from 00:01 (local time) 12/02/2024 until 23:59 (local time) 18/02/2024 at Countdown Supermarkets, Countdown Metro and Countdown Online. Offer period is based on the local time of the store you shop at in-store or that fulfils your Woolworths Online order. This offer is personal to you, and will only be available on your Everyday Rewards Card. Registered Everyday Rewards members must boost this offer to participate in the promotion. To ensure your offer has been added to your Everyday Rewards Card, boost your offer before shopping in-store or online. ^Points offer is only valid for each listed product in the size and variant described in this email. Pricing and stock availability may vary by store. To enjoy your offer in-store, you must boost this offer and scan your Everyday Rewards Card before completing your transaction; to enjoy your offer online, ensure your Everyday Rewards Card number is linked to your online account at checkout. For all Countdown Online transactions, orders need to be placed by 23:59 (local time) on 29/11/22 to collect 200 points. Offer can be enjoyed multiple times during the promotional period. If you are eligible for multiple points offers on the same product, 1 standard point will be collected once only for all such offers, plus the applicable number of additional points. See [www.Countdown.co.nz](https://www.Countdown.co.nz) for full Terms and Conditions applicable to shopping at Countdown Online. Your Everyday Rewards points will be loaded onto your Everyday Rewards Card within 5 days  after your qualifying shop. You will not collect any points on any qualifying shop in the promotional period before boosting your offer. In addition to the above terms and conditions, by participating in the Everyday Rewards program you agree to the Everyday Rewards T&Cs at [www.everydayrewards.co.nz/terms](https://www.everydayrewards.co.nz/terms)\n\nCampaign code: ITM-0002',
			offerStatus: 'Activated',
			divisionPartnerIds: ['2010'],
			rewardValue: {
				points: 150.0,
				value: 150.0,
				type: 'points_fixed',
				display: '150',
			},
			backgroundImage: {
				desktop: 'https://assets.woolworths.com.au/images/2010/71358.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				mobile: 'https://assets.woolworths.com.au/images/2010/71358.jpg?impolicy=wowcdxwbjbx&w=900&h=900',
				altText: 'Ziploc Snack 60 pack',
			},
			redemption: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
				total: 1,
				remaining: 1,
				eligibleSalesChannels: ['ONLINE_WEB', 'ONLINE_APP', 'INSTORE', 'INSTORE_SELF_CHECKOUT', 'SCAN_AND_GO'],
			},
			activation: {
				startDate: '2024-02-12T00:00:01+13:00',
				endDate: '2024-02-18T23:59:59+13:00',
			},
			products: [],
			productCount: 5,
			cta: {
				destinationUrl: 'https://www.countdown.co.nz/',
				dateMessage: 'Ends 18 Feb',
				label: 'Shop',
			},
			offerType: 'OTHER',
			minimumSpend: 0,
			displayLocation: 'PRODUCT_OFFERS',
		},
	],
};
